import { DocumentCard } from '@zorro/design-system/v2/DocumentCard';
import { Text } from '@zorro/web/design-system';

type Props = {
  /** File name shown on the card. */
  name?: string;
  onClickDelete: () => void;
  onClickDownload?: () => void;
  /** Field label rendered above the card. Omit for a bare card. */
  label?: string;
  isRequired?: boolean;
  /** Drops the remove action, leaving the card read-only. */
  isReadonly?: boolean;
  /** `secondary` is the compact chip used in evidence lists. */
  variant?: 'primary' | 'secondary';
  description?: string;
  date?: string;
};

/**
 * A picked-or-stored file as a form field: the design system's `DocumentCard`
 * under a field label. Removal is the card's only action, so it renders as a
 * direct trash button rather than behind a ⋯ menu — `deleteLabel` names that
 * button instead of a menu item.
 */
export const UploadedFileBox = ({
  name,
  onClickDelete,
  onClickDownload,
  label,
  isRequired = false,
  isReadonly = false,
  variant = 'primary',
  description,
  date,
}: Props) => (
  <>
    {label && (
      <Text size="sm" fw={400} lts="sm" mb="xs">
        {label}
        {isRequired && '*'}
      </Text>
    )}
    <DocumentCard
      variant={variant === 'secondary' ? 'minimal' : 'shadow'}
      fileName={name ?? ''}
      description={description}
      date={date}
      onDownload={onClickDownload}
      onDelete={isReadonly ? undefined : onClickDelete}
      deleteLabel="Remove"
    />
  </>
);
